/* eslint-disable no-console */
import { takeLatest, call, put } from 'redux-saga/effects';
import safeSaga from '../safeSaga';

import { FAV_SAVE_INIT } from '../../actions/actionTypes';
import { getLists } from '../../api/favouritesApi';
import { displayFavoriteModal, updateMemberFavouriteList } from '../../actions/favoriteAction';

function* getFavourites() {
  try {
    const memberId = window.THDCustomer?.default?.svocID || '';
    if (memberId) {
      const response = yield call(getLists, memberId);
      const {
        listResponse: { list: listItems },
      } = response;
      const { listId, listName } = listItems && listItems[0];

      yield put(displayFavoriteModal());
      yield put(updateMemberFavouriteList({ listId, listName }));
    }
  } catch (err) {
    console.log(err);
    throw err;
  }
}

export default function* getFavouritesSaga() {
  yield takeLatest(FAV_SAVE_INIT, safeSaga(getFavourites));
}
